import React from 'react';
import PropTypes from 'prop-types';

export function OrientationStatusBlock(props) {
  const setClassName = () => {
    return `${props.className}_status ${
      props.orientation === "180" ? 'correct' : 'incorrect'
    }`;
  };

  const getStatus = () => (props.orientation == "180" ? 'Yes' : 'No');

  return (
    <div className={`${props.className}_block`}>
      <div className={props.className}>
        <h3>WARNING!</h3>
        {/*<p className={`${props.className}_message`}></p>*/}
        <p className={setClassName()} style={{background: "rgba(51,51,51,0.5)", padding: "4px", borderRadius: "5px"}}>Gel in correct orientation: {getStatus()}</p>
      </div>
    </div>
  );
}

OrientationStatusBlock.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set the Microcentrifuge Orientationd Status Yes/No
   */
  orientation: PropTypes.int,
};

OrientationStatusBlock.defaultProps = {};
